import React from 'react';
import PropTypes from 'prop-types';
import { ModalHeader, ModalFooter } from 'reactstrap';
import css from 'styled-jsx/css';

import ModalLayout from '../ModalLayout';

const { className: footerClassName, styles: footerStyles } = css.resolve`
  @media (min-width: 768px) {
    div {
      border-top: none;
    }
  }
`;

export default function RawAPIModal(props) {
  return (
    <ModalLayout
      isOpen={props.isOpen}
      toggleModal={props.toggleModal}
      scrollable={true}
      style={{ maxWidth: '1600px', width: '80%' }}
    >
      <ModalHeader className="border-bottom-0" toggle={props.toggleModal}>
        {props.title}
      </ModalHeader>
      <pre className="modal-body pt-5 px-md-5">
        <code>{props.data}</code>
      </pre>
      <ModalFooter
        className={`justify-content-between justify-content-md-end ${footerClassName}`}
      >
        <button
          className="btn btn-sm btn-outline-icon-link-gray bg-white text-muted shadow-none py-0 px-3 ml-md-3 three-quarter-text"
          onClick={props.toggleModal}
        >
          Close
        </button>
      </ModalFooter>
      {footerStyles}
    </ModalLayout>
  );
}

RawAPIModal.propTypes = {
  data: PropTypes.string,
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
};

RawAPIModal.defaultProps = {};
